import { disableElement, enableElement } from '@fretadao/f-js-dom';
import { Controller } from '@hotwired/stimulus';
import { application } from 'src';

application.register('custom-dropdown', class extends Controller {
  static targets = ['dropdown'];

  connect() {
    this.dropdownTargets.forEach(target => this.#setDefaultAttributes(target));
  }

  changeCheckbox(event) {
    const changedDropdown = event.target;
    const previousOption = changedDropdown.getAttribute('previous');
    const currentOption = changedDropdown.selectedIndex;

    this.#changeProperty(
      changedDropdown,
      changedDropdown.options[previousOption].getAttribute('key'),
      changedDropdown.options[currentOption].getAttribute('key')
    );

    if(changedDropdown.selectedIndex != 0){
      if (previousOption != 0) this.#toggleDropdown(changedDropdown, previousOption, false);

      this.#toggleDropdown(changedDropdown, changedDropdown.selectedIndex, true);
    } else {
      this.#toggleDropdown(changedDropdown, previousOption, false);
    }

    changedDropdown.setAttribute('previous', changedDropdown.selectedIndex);
  }

  #toggleDropdown(changedDropdown, optionToDisable, willDisable) {
    let toggleElement = willDisable ? disableElement : enableElement;

    this.dropdownTargets.forEach(target => {
      if (target.id != changedDropdown.id) {
        toggleElement(target.options[optionToDisable])

        if (target.selectedIndex == changedDropdown.selectedIndex && willDisable){
          target.selectedIndex = 0;
        }
      }
    });
  }

  #changeProperty(target, previousOption, currentOption) {
    target.setAttribute('id', target.id.replace(previousOption, currentOption));
    target.setAttribute('name', target.name.replace(previousOption, currentOption));
  }

  #setDefaultAttributes(target) {
    target.setAttribute('previous', target.selectedIndex);
    Array.from(target.options).forEach((option) => {
        option.setAttribute('key', option.value);
        option.setAttribute('value', target.getAttribute('key'));
      }
    );
  }
});

